import { Button, Header, Icon } from '@circlefin/components'
import { invoicesSection } from '@services/sections/lib/billing'
import { BackButton } from '@shared/components/layout'
import useTranslation from 'next-translate/useTranslation'

import { InvoiceDescription } from '../InvoiceDescription/InvoiceDescription'
import { InvoiceSummary } from '../InvoiceSummary/InvoiceSummary'

import type { InvoiceDetail } from '@shared/graphql'

export interface InvoiceDetailsCardProps {
  /**
   * The invoice detail that should be displayed.
   */
  invoiceDetail: InvoiceDetail
  /**
   * Additional classes that will be applied to the element.
   */
  className?: string
}

export const InvoiceDetails: React.FC<InvoiceDetailsCardProps> = ({
  className,
  invoiceDetail,
}) => {
  const { t } = useTranslation('settings')

  return (
    <>
      <BackButton section={invoicesSection} />
      <Header variant="secondary">
        <Header.Head
          data-testid="header"
          title={t('billing.invoices.details.title', {
            invoiceNumber: invoiceDetail?.invoiceNumber,
          })}
        >
          <Button.Link
            data-testid="export-button"
            href={invoiceDetail?.invoiceLink}
            size="sm"
            variant="primary"
          >
            <span>{t('billing.invoices.details.downloadInvoice')}</span>
            <Icon className="ml-2" name="DownloadSolid" />
          </Button.Link>
        </Header.Head>
      </Header>

      <InvoiceSummary
        className={className}
        data-testid="invoice-summary"
        invoiceDetail={invoiceDetail}
      />

      <InvoiceDescription
        className={className}
        data-testid="invoice-description"
        invoiceDetail={invoiceDetail}
      />
    </>
  )
}
